<template>
  <div class="car-recommend" v-show="cars.length > 0">
    <div class="car-recommend__container">
      <!-- 标题栏 -->
      <div class="car-recommend__title">
        <div class="car-recommend__heading">Top Cars</div>
        <div class="car-recommend__view" @click="gotoAll()">
          <div class="car-recommend__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="car-recommend__icon" alt="view all icon">
        </div>
      </div>

      <!-- 加载状态 - 临时隐藏 -->
      <!-- <div v-if="loading" class="car-recommend__loading">
        <div class="car-recommend__loading-text">Loading...</div>
      </div> -->

      <!-- 卡片容器 - PC版添加导航按钮，移动版使用横向滚动 -->
      <div class="car-recommend__cards-wrapper">
        <!-- 左侧导航箭头 - 只在PC显示 -->
        <div v-if="shouldShowArrows" class="car-recommend__nav-arrow car-recommend__nav-arrow--left"
          @click="prevPage" :class="{'car-recommend__nav-arrow--disabled': currentPage === 0}">
          <svg class="car-recommend__arrow-icon car-recommend__arrow-icon--left"
            xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
            <path
              d="M1.81151 6L5.78094 1.46355C6.07302 1.12975 6.07302 0.584148 5.78094 0.250349C5.48887 -0.0834497 5.01146 -0.0834497 4.71938 0.250349L0.218581 5.39407C0.145855 5.47718 0.0907245 5.5737 0.0543615 5.67693C-0.00898042 5.8579 -0.0171914 6.05898 0.0309015 6.24532C0.0379395 6.27213 0.0461505 6.2976 0.0543615 6.32441C0.0907245 6.42764 0.145855 6.52416 0.218581 6.60727L4.71821 11.7497C5.01028 12.0835 5.48769 12.0835 5.77977 11.7497C6.07185 11.4159 6.07185 10.8702 5.77977 10.5364L1.81151 6Z"
              fill="white" />
          </svg>
        </div>

        <!-- 卡片容器 -->
        <div class="car-recommend__cards"
          :class="{'car-recommend__cards--mobile': deviceType === 'mobile'}">

          <!-- 单个卡片 -->
          <div v-for="(car, index) in displayedCars" :key="`car-${index}`"
            class="car-recommend__card" @click="gotoDetail(car)">

            <!-- 卡片头部区域 -->
            <div class="car-recommend__card-header">
              <!-- 车辆品牌和Logo -->
              <div class="car-recommend__brand-info">
                <img :src="car.logo" class="car-recommend__logo" alt="car logo">
                <div class="car-recommend__brand-text">
                  <div class="car-recommend__model">{{ car.model }}</div>
                  <div class="car-recommend__brand">{{ car.brand }}</div>
                </div>
              </div>
            </div>

            <!-- 车辆图片 -->
            <div class="car-recommend__image-container">
              <img :src="car.image" class="car-recommend__pic" alt="car image">
            </div>

            <!-- 车辆信息区域 -->
            <div class="car-recommend__info-section">
              <!-- 车辆详情信息 -->
              <div class="car-recommend__info-row">
                <div class="car-recommend__info-item">
                  <img src="@/assets/calendar.svg" class="car-recommend__info-icon"
                    alt="calendar icon">
                  <div class="car-recommend__info-text">{{ car.year }}</div>
                </div>
                <div class="car-recommend__info-item">
                  <img src="@/assets/car-type.svg" class="car-recommend__info-icon"
                    alt="car type icon">
                  <div class="car-recommend__info-text">{{ car.category }}</div>
                </div>
                <div class="car-recommend__info-item">
                  <img src="@/assets/body-type.svg" class="car-recommend__info-icon"
                    alt="body type icon">
                  <div class="car-recommend__info-text">{{ car.bodyType }}</div>
                </div>
              </div>

              <!-- 信息分隔线 -->
              <div class="car-recommend__divider"></div>

              <!-- 价格和查看按钮 -->
              <div class="car-recommend__price-row">
                <div class="car-recommend__price-info">
                  <div class="car-recommend__price-label">Price</div>
                  <div class="car-recommend__price-value">{{ car.price }}</div>
                </div>
                <div class="car-recommend__view-btn">
                  <div class="car-recommend__view-text">View Now</div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- 右侧导航箭头 - 只在PC显示 -->
        <div v-if="shouldShowArrows"
          class="car-recommend__nav-arrow car-recommend__nav-arrow--right" @click="nextPage"
          :class="{'car-recommend__nav-arrow--disabled': currentPage >= maxPage}">
          <svg class="car-recommend__arrow-icon" xmlns="http://www.w3.org/2000/svg" width="6"
            height="12" viewBox="0 0 6 12" fill="none">
            <path
              d="M4.18849 6L0.219058 1.46355C-0.073019 1.12975 -0.073019 0.584148 0.219058 0.250349C0.511134 -0.0834497 0.988545 -0.0834497 1.28062 0.250349L5.78142 5.39407C5.85414 5.47718 5.90928 5.5737 5.94564 5.67693C6.00898 5.8579 6.01719 6.05898 5.9691 6.24532C5.96206 6.27213 5.95385 6.2976 5.94564 6.32441C5.90928 6.42764 5.85414 6.52416 5.78142 6.60727L1.28179 11.7497C0.989717 12.0835 0.512307 12.0835 0.22023 11.7497C-0.0718465 11.4159 -0.0718465 10.8702 0.22023 10.5364L4.18849 6Z"
              fill="white" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarRecommend',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      originalTopCars: 'originalTopCars',
      topCarsLoaded: 'topCarsLoaded',
      domainConfig: 'domainConfig'
    }),
    // 从 Vuex 获取并处理车辆数据
    processedCars () {
      if (!Array.isArray(this.originalTopCars) || this.originalTopCars.length === 0) {
        return [];
      }

      // 处理API返回的数据，并限制最多显示8条
      return this.originalTopCars.slice(0, 8).map(item => {
        // 从photos字段提取第一张图片作为封面
        const photos = item.photos ? item.photos.split(',') : [];
        const firstPhoto = photos.length > 0 ? photos[0] : require('@/assets/car-recommend-img.png');

        // 返回处理后的数据，映射字段名称
        return {
          id: item.id,
          model: item.name, // API中是name字段，映射为model
          brand: item.brand,
          logo: item.logoUrl || require('@/assets/car-logo.svg'), // 使用默认logo，因为API中没有提供
          year: item.year || item.marketTime?.substring(0, 4) || '-',
          category: item.purpose || '-', // 使用purpose字段作为category
          bodyType: item.type || '-', // 使用type字段作为bodyType
          price: this.formatPrice(item.leastPrice, item.mostPrice) || item.price || '-',
          image: item.cover || firstPhoto, // 使用cover字段，如果没有则使用firstPhoto
          speedValue: item.accelerationTime ? `${item.accelerationTime}s` : '-' // 添加's'后缀
        };
      });
    },
    // 是否应该显示导航箭头（PC模式且数据超过3条）
    shouldShowArrows () {
      return (this.deviceType === 'desktop' || this.deviceType === 'pc') && this.cars.length > 3;
    },
    // 计算最大页码
    maxPage () {
      if (this.cars.length <= 3) return 0;
      return Math.ceil(this.cars.length / 3) - 1;
    },
    // 当前页应该显示的卡片
    displayedCars () {
      // 移动端显示所有卡片
      if (this.deviceType === 'mobile') {
        return this.cars;
      }
      // PC端根据当前页显示3个卡片
      const startIndex = this.currentPage * 3;
      return this.cars.slice(startIndex, startIndex + 3);
    }
  },
  data () {
    return {
      cars: [],
      loading: false,
      error: null,
      currentPage: 0 // 当前显示的页码，0表示第一页
    }
  },
  watch: {
    // 监听处理后的数据变化，更新本地cars数组
    processedCars: {
      immediate: true,
      handler (newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.cars = newVal;
          this.loading = false;
          // 重置当前页码
          this.currentPage = 0;
        }
      }
    },
    // 监听Vuex中数据加载状态
    topCarsLoaded (newVal) {
      if (!newVal) {
        // 如果数据未加载，则请求主组件获取数据
        this.requestDataFromHomeHero();
      }
    }
  },
  mounted () {
    // 检查Vuex中是否已有数据，如果没有则通知HomeHero组件获取
    if (!this.topCarsLoaded || !Array.isArray(this.originalTopCars) || this.originalTopCars.length === 0) {
      this.requestDataFromHomeHero();
    }
  },
  methods: {
    // 切换到上一页
    prevPage () {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },
    // 切换到下一页
    nextPage () {
      if (this.currentPage < this.maxPage) {
        this.currentPage++;
      }
    },
    // 通知HomeHero组件获取数据
    requestDataFromHomeHero () {
      this.loading = true;
      // 发布自定义事件，通知HomeHero组件获取数据
      this.$root.$emit('fetch-top-cars');
      console.log('[CarRecommend] Requested data from HomeHero');
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },
    // 跳转到全部车辆页面
    gotoAll () {
      // 获取当前路由的channel参数
      const currentChannel = this.$router.currentRoute.params.channel;

      // 如果存在channel参数，则构建带channel的路径
      if (currentChannel) {
        // 构建完整URL
        const baseUrl = window.location.origin;
        // 直接获取当前URL的查询字符串，包括?前缀
        const fullQueryString = window.location.search;
        const fullPath = `${baseUrl}/${currentChannel}/car-list${fullQueryString}`;

        // 使用location跳转
        console.log(fullPath);
        window.location.href = fullPath;
      } else {
        // 没有channel参数，使用常规router跳转
        this.$router.push({
          path: '/car-list'
        });
      }
    },

    // 跳转到车辆详情页面
    gotoDetail (car) {
      if (!car || !car.id) {
        console.warn('[CarRecommend] Missing car data for detail page');
        return;
      }

      // 获取当前路由的channel参数
      const currentChannel = this.$router.currentRoute.params.channel;

      // 格式化车辆名称，去除空格，用连字符替代
      const formattedName = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));

      // 如果存在channel参数，则构建带channel的路径
      if (currentChannel) {
        // 获取当前的查询参数
        const currentQuery = this.$route.query;
        const queryString = new URLSearchParams(currentQuery).toString();
        const fullQueryString = queryString ? `?${queryString}` : '';

        // 构建完整URL
        const baseUrl = window.location.origin;
        const fullPath = `${baseUrl}/${currentChannel}/cars/${formattedName}/${car.id}${fullQueryString}`;

        // 使用location跳转，保留所有参数
        window.location.href = fullPath;
      } else {
        // 没有channel参数，使用常规router跳转
        this.$router.push({
          path: `/cars/${formattedName}/${car.id}`
        });
      }
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-recommend {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	padding: rem(60) 0;
	width: 100%;

	&__container {
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		width: 100%;
		padding: 0 rem(120);
	}

	&__title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
	}

	&__heading {
		color: #141414;
		text-align: left;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 700;
		position: relative;
	}

	&__view {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
		transition: opacity 0.3s ease;

		&:hover {
			opacity: 0.7; /* View All按钮hover时透明度减少30% */
		}
	}

	&__view-all {
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 600;
		color: var(--theme-color);
	}

	&__icon {
		flex-shrink: 0;
		width: rem(16);
		height: rem(16);
		position: relative;
		overflow: visible;
	}

	&__cards-wrapper {
		display: flex;
		align-items: center;
		width: 100%;
		position: relative;
	}

	&__nav-arrow {
		width: rem(24);
		height: rem(24);
		border-radius: rem(8);
		background: #141414;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		position: absolute;
		z-index: 10;
		transition: all 0.3s ease;

		&:hover {
			// background: #f5f5f5;
			opacity: 0.7;
		}

		&--left {
			left: rem(-40);

			.car-recommend__arrow-icon {
				transform: rotate(360deg);
			}
		}

		&--right {
			right: rem(-40);
		}

		&--disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}
	}

	&__arrow-icon {
		width: rem(6);
		height: rem(12);
	}

	&__cards {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: nowrap; /* 修改：统一使用nowrap，通过JS控制显示数量 */
		align-content: flex-start;
		align-self: stretch;
		width: 100%;
		position: relative;
		// padding: 0 rem(80); /* 添加左右内边距 */

		// 移动端横向滚动样式
		&--mobile {
			overflow-x: auto;
			padding: 0; /* 移动端不需要内边距 */
			scrollbar-width: none; // Firefox
			-ms-overflow-style: none; // IE and Edge

			&::-webkit-scrollbar {
				display: none; // Chrome, Safari, Opera
			}
		}
	}

	&__card {
		background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 50%, rgba(var(--theme-color-r), var(--theme-color-g), var(--theme-color-b), 0.08) 100%);
		border-radius: rem(24);
		border: 1px solid #e9e9e9;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		flex: 0 0 calc((100% - rem(40)) / 3); /* 使每个子元素占1/3的宽度 */
		position: relative;
		cursor: pointer;
		transition: transform 0.3s ease;

		&:hover {
			transform: translateY(-4px); /* 悬停时上移4px */
		}
	}

	&__card-header {
		padding: rem(20);
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__brand-info {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	&__logo {
		background: linear-gradient(to left, #ffffff, #ffffff);
		border-radius: 100px;
		border: 1px solid #e9e9e9;
		width: rem(40);
		height: rem(40);
		object-fit: cover;
		flex-shrink: 0;
		aspect-ratio: 1; /* 新增：保持1:1比例 */
	}

	&__brand-text {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	&__model {
		color: #141414;
		text-align: left;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 600;
		position: relative;
		align-self: stretch;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	&__brand {
		color: #777777;
		text-align: left;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		position: relative;
		align-self: stretch;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	&__image-container {
		padding: 0 rem(20);
		display: flex;
		flex-direction: column;
		gap: rem(10);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__pic {
		border-radius: rem(16);
		border: 1px solid #ffffff;
		align-self: stretch;
		flex-shrink: 0;
		height: rem(230);
		position: relative;
		object-fit: cover;
	}

	&__info-section {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__info-row {
		padding: rem(16) 0;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__info-item {
		border-radius: rem(4);
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;
	}

	&__info-icon {
		flex-shrink: 0;
		width: rem(20);
		height: rem(20);
		position: relative;
	}

	&__info-text {
		color: #141414;
		text-align: center;
		font-size: rem(12);
		line-height: rem(14);
		font-weight: 400;
		position: relative;
		align-self: stretch;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__divider {
		margin: 0 rem(20);
		background: #ffffff;
		align-self: stretch;
		flex-shrink: 0;
		height: rem(2);
		position: relative;
	}

	&__price-row {
		padding: rem(20);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__price-info {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	&__price-label {
		color: #777777;
		text-align: center;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__price-value {
		color: #141414;
		text-align: center;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 600;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__view-btn {
		background: var(--theme-color);
		border-radius: rem(8);
		padding: rem(10) rem(8);
		display: flex;
		flex-direction: row;
		gap: rem(8);
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		width: rem(100);
		position: relative;
	}

	&__view-text {
		color: #ffffff;
		text-align: left;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 500;
		position: relative;
	}

	&__bg-gradient {
		background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 50%, rgba(var(--theme-color-r), var(--theme-color-g), var(--theme-color-b), 0.08) 100%);
	}

	&__button {
		background: var(--theme-color);
	}
}

// 设备类型样式 - PC
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-recommend {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 设备类型样式 - Mobile
.detect_deviece_mobile {
	.car-recommend {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);

		&__container {
			padding: 0 0 0 rem(16);
		}

		&__title {
			padding-right: rem(16);
		}

		&__cards {
			padding: 0; /* 移动端不需要内边距 */
			gap: rem(8);
		}

		&__card {
			width: rem(320);
			flex-shrink: 0;
			flex: none;
			// margin-right: rem(10);

			&:last-child {
				margin-right: 0;
			}
		}
	}
}
</style> 